<div class="login-page">
    <section class="login-panel">
        <div class="logo-wrap">
            <img alt="SpeedTaxi logo" src="assets/images/logo-speed-taxi.svg">
        </div>

        <form #f="ngForm" (ngSubmit)="onSignin(f)" id="formLogin">
            <label class="field-group" for="username">
                <span>{{ 'Username' | translate }}</span>
                <div class="input-shell">
                    <i class="material-icons">person</i>
                    <input [placeholder]="'Username' | translate" class="form-control" id="username" name="username"
                           ngModel
                           required type="text">
                </div>
            </label>

            <label class="field-group" for="password">
                <span>{{ 'Password' | translate }}</span>
                <div class="input-shell">
                    <i class="material-icons">lock</i>
                    <input [placeholder]="'Password' | translate" class="form-control" id="password" name="password"
                           ngModel
                           required type="password">
                </div>
            </label>

            <button [disabled]="!f.valid" [ngClass]="{'disableCursor': !f.valid}" class="btn btn-info login-button"
                    type="submit">
                {{ 'Sign In' | translate }}
            </button>

            @if (loginFailed) {
                <div class="login-error">
                    {{ 'Username or password are incorrect.' | translate }}
                </div>
            }
        </form>
    </section>
</div>
